import Seo from "@/components/seo/Seo";
import SkipLink from "@/components/a11y/SkipLink";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import SocialProof from "@/components/landing/SocialProof";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import Workflow from "@/components/landing/Workflow";
import AISection from "@/components/landing/AISection";
import Screenshots from "@/components/landing/Screenshots";
import WhyUs from "@/components/landing/WhyUs";
import UseCases from "@/components/landing/UseCases";
import Testimonials from "@/components/landing/Testimonials";
import Pricing from "@/components/landing/Pricing";
import FAQ, { FAQS } from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import FloatingCTA from "@/components/landing/FloatingCTA";
import { DEFAULT_DESCRIPTION } from "@/lib/seo/site";
import {
  graph,
  softwareApplication,
  product,
  faqPage,
  webPage,
} from "@/lib/seo/structuredData";

const jsonLd = graph([
  softwareApplication(),
  product(),
  faqPage(FAQS),
  webPage({
    path: "/",
    name: "SocialLead AI — AI Social Lead Discovery & Engagement Platform",
    description: DEFAULT_DESCRIPTION,
    breadcrumbItems: [{ name: "Home", path: "/" }],
  }),
]);

export default function Landing() {
  return (
    <>
      <Seo path="/" jsonLd={jsonLd} />
      <SkipLink />
      <Nav />
      <main id="main-content" data-testid="landing-page" className="relative min-h-screen bg-[var(--bg)] text-white">
        <Hero />
        <SocialProof />
        <Problem />
        <Solution />
        <Workflow />
        <AISection />
        <Screenshots />
        <WhyUs />
        <UseCases />
        <Testimonials />
        <Pricing />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
    </>
  );
}
